import { render, staticRenderFns } from "./ListPerfis.vue?vue&type=template&id=21fd3c03"
import script from "./ListPerfis.vue?vue&type=script&lang=js"
export * from "./ListPerfis.vue?vue&type=script&lang=js"
import style0 from "./ListPerfis.vue?vue&type=style&index=0&id=21fd3c03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports